import React from "react";
import { Spinner } from "react-bootstrap";
const ActivityIndigator = () => {
  return (
    <Spinner
      as="span"
      animation="grow"
      size="sm"
      role="status"
      aria-hidden="true"
    />
  );
};

export default ActivityIndigator;
